import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function AuditLogs() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
        Audit Logs
      </Typography>
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          Audit Logs Coming Soon
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This will include security logs, user actions, and system changes tracking.
        </Typography>
      </Paper>
    </Box>
  );
}
